module.exports = __webpack_public_path__ + "static/assem3-da59d097ea54dd9a1633e8d133bf2afd.gif";